"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateTransform = exports.calculateWidth = void 0;
var calculateWidth = function calculateWidth(_ref) {
  var circleSize = _ref.circleSize,
    numberOfStages = _ref.numberOfStages;
  return "calc((100% - ".concat(circleSize * numberOfStages, "px) / ").concat(numberOfStages - 1, ")");
};
exports.calculateWidth = calculateWidth;
var calculateTransform = function calculateTransform(_ref2) {
  var circleSize = _ref2.circleSize;
  return "translate(0, ".concat((circleSize - 5) / 2, "px)");
};
exports.calculateTransform = calculateTransform;